import { initDataSetOrder } from '@/utils/modules/payment'
import OrderProvider from '@/resources/order_provider'
import MemberOrderProvider from '@/resources/member_order_provider'
import { getUserCashier } from '@/utils/helper/localStorage'
const orderProvider = new OrderProvider()
const memberOrderProvider = new MemberOrderProvider()

const state = {
  type: '',
  change: '',
  receivedPromoCode: '',
  receivedMoney: {
    receivedCash: '',
    receivedCard: ''
  },
  total: '',
  order: {},
  time: ''
}

const actions = {
  async setOrder ({commit, getters, state}, payload) {
    commit('SET_TOTAL')
    const cashier = getUserCashier()
    const params = initDataSetOrder(payload, state, getters.getTel, getters.billExpire)
    const promotionCode = JSON.parse(JSON.stringify(getters.promotionCodeDetail))
    delete promotionCode.for_member_ids
    delete promotionCode.forMemberIds
    const discount = getters.discount
    const order = await orderProvider.posCompleteCart(params)
    const createMemberOrderHistory = await memberOrderProvider.createOrderHistory({
      order: order,
      memberOrderHistory: {},
      tel: getters.getTel,
      items: getters.getItems,
      promotionCode: promotionCode,
      cashier: cashier,
      discount
    })
    commit('SET_ORDER', order)
    commit('SET_MEMBER_ORDER_HISTORY', createMemberOrderHistory)
    return createMemberOrderHistory
  },
  calculatedChange ({commit}, payload) {
    commit('CALCULATED_CHANGE', payload)
  },
  setChange ({commit}, payload) {
    commit('SET_CHANGE', payload)
  },
  setReceivedCash ({commit}, payload) {
    commit('SET_RECEIVE_CASH', payload)
  },
  clearMoney ({commit}) {
    commit('CLEAR_MONEY')
  },
  async checkout ({ dispatch, getters, commit }, channel) {
    if (channel === 'Credit') {
      commit('SET_RECEIVED_CARD', getters.getNetPrice)
      commit('SET_RECEIVE_CASH', 0)
      commit('SET_CHANGE', 0)
    } else {
      commit('SET_RECEIVED_CARD', 0)
    }
    const payment = getters.paymentChannel
    await commit('SET_TYPE', payment.find(type => type.payment_name === channel))
    await commit('SET_TIME', new Date())
    await dispatch('setOrder', {items: getters.getItems, price: getters.getNetPrice})
  }
}

const mutations = {
  SET_TYPE: (state, payload) => {
    state.type = payload
  },
  SET_MEMBER_ORDER_HISTORY: (state, payload) => {
    state.memberOrderHistory = payload
  },
  SET_ORDER: (state, payload) => {
    state.order = payload
  },
  CALCULATED_CHANGE: (state, payload) => {
    state.receivedMoney.receivedCash = payload.receive
    state.change = state.receivedMoney.receivedCash - payload.netPrice
  },
  SET_CHANGE: (state, payload) => {
    state.change = payload
  },
  SET_RECEIVED_CARD: (state, payload) => {
    state.receivedMoney.receivedCard = payload
  },
  SET_RECEIVE_CASH: (state, payload) => {
    state.receivedMoney.receivedCash = payload
  },
  CLEAR_MONEY: (state) => {
    state.receivedMoney.receivedCard = 0
    state.receivedMoney.receivedCash = 0
    state.change = 0
  },
  SET_TIME: (state, payload) => {
    state.time = payload
  },
  SET_RECEIVE_PROMOCODE: (state, payload) => {
    state.receivedPromoCode = payload
  },
  SET_TOTAL: (state) => {
    state.total = state.receivedMoney.receivedCash + state.receivedMoney.receivedCard
  }
}

const getters = {
  getChange: (state) => {
    return state.change
  },
  getMemberOrderHistory: (state) => {
    return state.memberOrderHistory
  },
  getReceivedCash: (state) => {
    return state.receivedMoney.receivedCash
  },
  getReceivedCard: (state) => {
    return state.receivedMoney.receivedCard
  },
  getOrder: (state) => {
    return state.order
  },
  getBillID: (state) => {
    return (Object.keys(state.order).length === 0) ? '' : state.order.bill.id
  },
  getTime: (state) => {
    return state.time
  },
  getReceivedPromoCode: (state) => {
    return state.receivedPromoCode
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/payment.js